module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "chapter-1"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "x1chap-num"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062015471_Contents#chapter-1"
    }
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-first-with-overrides"
  }, [_c('span', {
    staticClass: "initial-caps"
  }, [_vm._v("U")]), _c('span', {
    staticClass: "generated-style-2"
  }, [_vm._v("ncle Edward had wandered off.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Ordinarily, it would have been little cause for alarm, as he often enjoyed an adventurous romp. But a grand celebration for his seventy-fifth birthday was scheduled this weekend, and the whole family was coming, maybe even Carleen, though no one knew that but Ellie, and Uncle Edward had sworn her to secrecy.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“I’ll try the boathouse,” Ellie shouted to Henry, Edward’s man-friend, whom she wanted to blame for the disappearance. After all, Henry and Edward were lovers, and Ellie suspected Henry had been pressuring him to commemorate the birthday by crossing the border into Connecticut and getting married, which no doubt would affect Edward’s will.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("But that wasn’t the problem right now.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Dashing from the terrace past the caterers, who were erecting a white-and-gold tent in the south garden, power-waddling down the embankment that led to the water at Lake Kasteel, Ellie prayed nothing had happened, that Uncle Edward hadn’t slipped on the rocks and fallen and broken his damn neck. He claimed to know every obstacle on his land, every tree root and stone, every hollow and hill, but five acres was a lot of ground, and sometimes he could be forgetful.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Besides, wouldn’t tree roots and stones (unlike some ornery people) shift and change over time?")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Edward had bought the place during his years as a producer, when all of Broadway had jostled and jockeyed for invitations to his Gatsbyish parties at this lavish summer playground north of New York City. Back then, Ellie, Amanda, Carleen, and Naomi (whom everyone simply called Babe) had hidden beneath the wide staircase in the mansion’s big foyer or in the fat, blue-blossomed hydrangea that cupped the slate terrace, and muted their giggles and gasps while they’d observed the comings and goings and in-betweens of this one and that, that one and this.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("It had been an exhilarating atmosphere (complete with high drama and carnival acts), an education of a most notable, inappropriate kind for four young sisters who summered with their uncle while their parents were doing whatever they did when they were")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sans kids")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Ellie had no idea if the voyeurism had harmed them.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Amanda had gone on to become a Park Avenue socialite, having married an architect who, Amanda hinted, often worked with The Donald. They had three children who were pretty but spoiled in a prep-school, lacrosse-playing way. They’d honored Edward with their presence last Christmas: it was clear they had come for the gifts.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Babe had become a star in her own right, a strawberry blonde, voluptuous leading lady, now wed to yesterday’s top-box-office, action-flick man who was much older but looked a lot younger thanks to a face-lift, maybe two. Ellie hadn’t seen her youngest sister since Babe had left home, but she kept up on her life via e-mails and phone calls and")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("People")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" and")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Us,")]), _vm._v(" "), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("though the media attention had dwindled proportionately with each passing year.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Carleen, well, Uncle Edward had insisted on inviting her, and perhaps he was right, perhaps it was time.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("As for Ellie, she’d had a quick marriage and a quicker divorce, thanks to Carleen. She’d moved from Manhattan back to Lake Kasteel, relinquishing her job as an Egyptologist at the Metropolitan Museum of Art and settling into cloistered recuperation far from public view.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Edward had decided, by then, to live in the mansion year round. So Ellie had become a kind of caretaker and, over time, had morphed into a beleaguering (she supposed) caregiver for him. The truth was, she was happier at home than out in the big world. After all they’d been through, who wouldn’t have been?")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("But now it was many years later and guests had been invited, including her sisters, because Edward was seventy-five.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Seventy-five, but missing. It just wouldn’t do.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“Uncle Edward!” Ellie cried as she reached the creaky old boathouse. “Where on earth are you?” She opened the slatted wooden door to the cottagelike structure and peered into the small, dark room. Mute wicker chairs stood wearing faded sheets; the air smelled like dampness and mildew and charcoal embers reminiscent of days when the cozy fireplace brought welcome relief from an unexpected storm.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("But it had been forever since those summers of boating and sunbathing and toasting marshmallows at the end of the day. Back then they’d all gotten along; they’d loved one another in spite of themselves.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“Uncle Edward, are you here?” Her tone escalated to exasperation. She opened the door to where the boats were. Water lap-lapped the sides of the canoe as it tipped back and forth, back and forth. But in the next bay, where the rowboat should have been harbored, there was nothing. The rowboat was gone. Just like Uncle Edward.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5785e53a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062015471_Chapter_1.vue
// module id = 69
// module chunks = 0